import React from 'react'
import { Form } from "antd";
import ResponsiveModal from "@components/ResponsiveModal";
import TreeSelect from "@components/ResponsiveTreeSelect";

export const MoveToModal = ({treeData, open, setOpen, moveForm, handleMoveTo, isTargetDisabled}) => {


  if(!open) {
    return null
  }
  const formatTreeData = (treeData) => treeData.map(item => {
    // R1：System 子树（含真实子孙目录）由调用方判定为只读目标，禁止移入
    const extraDisabled = typeof isTargetDisabled === 'function' ? Boolean(isTargetDisabled(item)) : false;
    if(Array.isArray(item.children) && item.children.length > 0) {
      return {
        value:  item.isRoot ? 'root' : item.id,
        title: item.title,
        label: item.title,
        children: formatTreeData(item.children),
        disabled: extraDisabled || (item.isSystem ? !item?.context?.canMove : false) ||
          // 托管目录：Announcement/Submission 接受移入，合同根目录不接受
          Boolean(item.is_system_managed && item?.context?.canMove !== true)
      }
    }
    return {
      value:  item.isRoot ? 'root' : item.id,
      label: item.title,
      title: item.title,
      disabled: extraDisabled || (item.isSystem ? !item?.context?.canMove : false) ||
        Boolean(item.is_system_managed && item?.context?.canMove !== true)
    }
  })

  return (<ResponsiveModal title="Move to" open={open} onCancel={() => setOpen(false)} onOk={handleMoveTo} destroyOnClose>
    <Form form={moveForm} autoComplete="off">
      <Form.Item label="Folder" name="folder" rules={[{required: true, message: 'Please select a destination folder'}]}>
        <TreeSelect
          treeData={formatTreeData(treeData)}
          showCheckedStrategy={TreeSelect.SHOW_PARENT}
          treeDefaultExpandAll
          placeholder="Select a folder..."
        />
      </Form.Item>
    </Form>
  </ResponsiveModal>)
}
